import axios from 'axios'
import * as enVariables from 'src/config/config'
interface Params {
  topic?: string | null
  subTopic?: string
  type?: string
}

export async function exportTopicsCsv(params: Params, token?: string) {
  const res = await axios.get(enVariables.API_HOST + '/api/reimport-els/download', {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return res
}
